module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu-expanded"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose,
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    staticClass: "refresh-frontend",
    attrs: {
      "index": ""
    },
    on: {
      "click": _vm.refreshFrontend
    }
  }, [_c('i', {
    staticClass: "fa fa-save white"
  }), _vm._v(" Wprowadź zmiany\n        ")]), _vm._v(" "), _vm._l((_vm.availableRoutes), function(item, index) {
    return [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      staticClass: "menu__item"
    }, [_vm._v(_vm._s(_vm.getRouteName(item)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: _vm.getChildPath(item.path, child.path),
        staticClass: "menu__item",
        attrs: {
          "index": _vm.getChildPath(item.path, child.path)
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(child)) + "\n                ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n            ")]) : _vm._e()]
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Wyloguj\n        ")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28684b3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarComponent.vue
// module id = 725
// module chunks = 0